<template>
  <vue-custom-scrollbar class="scroll_wrap">
    <v-row
      class="ma-0 px-6 px-md-15 py-5 bg-gray"
      align="center"
      justify="space-between"
    >
      <v-col cols="auto" class="pa-0">
        <v-row class="ma-0" align="center">
          <v-col cols="auto" class="pa-0 mr-5">
            <v-img src="~@/img/main_img_assignment.png"></v-img>
          </v-col>
          <v-col cols="auto" class="pa-0">
            <span class="tab-title mr-4">{{ $t('과제제출') }}</span>
            <span class="count">{{ noticeAddStepList.length }}</span>
            <span class="unit">&nbsp;{{ $t('건') }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mx-0 mx-md-15 mt-4 mt-md-8 mb-0">
      <v-col class="pa-0">
        <template
          v-for="(noticeGroup, type) in groupBy(noticeAddStepList, 'notiType')"
        >
          <v-row
            :key="type"
            class="ma-0 px-6 py-4 bg-gray bd-B-2px"
            align="center"
            justify="space-between"
          >
            <v-col cols="auto" class="pa-0 head-title">{{
              type == 'ADDETC' ? $t('부가정보') : $t('과제제출')
            }}</v-col>
            <v-col cols="auto" class="pa-0">
              <a class="submit-count">{{ noticeGroup.length }}</a
              >{{ $t('건') }}
            </v-col>
          </v-row>
          <!-- only PC -->
          <v-row
            v-for="(notice, idx) in noticeGroup"
            class="ma-0 py-5 px-6 bd-B-1px d-none d-md-flex"
            align="center"
            justify="space-between"
            :key="'notice-pc' + idx + notice.id.addStepId + notice.notiType"
          >
            <v-col cols="" class="pa-0 list-title">{{ notice.title }}</v-col>
            <v-col cols="auto" class="pa-0 ml-10 date-created"
              >{{ $t('제출 기간')
              }}<span class="ml-3"
                >{{ notice.startDate | momentDate('YYYY-MM-DD') }}~{{
                  notice.endDate | momentDate('YYYY-MM-DD')
                }}</span
              ><span
                class="ml-8"
                :class="{ 'todo-complete': notice.complete }"
                >{{
                  type == 'ADDETC'
                    ? notice.complete
                      ? $t('입력완료')
                      : $t('미입력')
                    : notice.complete
                    ? $t('제출완료')
                    : $t('미제출')
                }}</span
              ></v-col
            >
            <v-col cols="auto" class="pa-0">
              <i-btn
                :class="[
                  notice.complete ? 'btn-type-03' : 'btn-type-06',
                  'ml-6',
                ]"
                @click="openTodoPopup(notice)"
                >{{
                  type == 'ADDETC'
                    ? notice.complete
                      ? $t('내용 보기')
                      : $t('입력')
                    : notice.complete
                    ? $t('내용 보기')
                    : $t('제출')
                }}</i-btn
              >
            </v-col>
          </v-row>
          <!-- only mobile & tablet -->
          <v-row
            v-for="(notice, idx) in noticeGroup"
            class="ma-0 px-6 py-5 bd-B-1px d-sm-block d-md-none"
            align="center"
            justify="space-between"
            :key="'notice-mobile' + idx + notice.id.addStepId + notice.notiType"
          >
            <v-row class="px-3 px-md-0 py-3 py-md-0">
              <v-col>
                <v-row cols="" class="pa-0 list-title">{{
                  notice.title
                }}</v-row>
                <v-row cols="auto" class="pa-0 date-created"
                  >{{ $t('제출 기간') }}
                  {{ notice.startDate | momentDate('YYYY-MM-DD') }}~{{
                    notice.endDate | momentDate('YYYY-MM-DD')
                  }}</v-row
                >
                <v-row cols="auto" class="pa-0 pt-3">
                  <span :class="{ complete: notice.complete }">{{
                    notice.complete ? $t('제출완료') : $t('미제출')
                  }}</span>
                  <i-btn class="ml-6 btn-type-03" @click="openTodoPopup(notice)"
                    >제출</i-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-row>
        </template>
      </v-col>
    </v-row>

    <BasePopup
      title="과제 제출"
      v-model="assignmentPopup"
      v-if="todoNotice"
      width="600"
    >
      <template v-if="todoNotice">
        <v-row class="ma-0 pa-0 inner-padding">
          <v-col cols="12" class="pa-0 pt-4 text-center">
            <v-avatar color="#f2f2f2" size="100">
              <div class="accept-icon-wrap">
                <v-img class="mx-auto" src="~@/img/assignment_img_upload.png" />
              </div>
            </v-avatar>
          </v-col>
        </v-row>
        <p class="modal-desc text-center mt-3" style="white-space: pre-wrap;">
          {{ todoNotice.notiDesc }}
        </p>
        <v-row class="my-0 mx-n8">
          <v-col cols="12" class="mt-4 px-8 py-6 mb-n6 text-center info-wrap">
            <p class="info-title d-flex align-center justify-center">
              <v-icon
                size="20"
                color="#000000"
                class="material-icons-outlined mdi"
                >date_range</v-icon
              ><span>{{ $t('제출 기간') }}</span
              ><span class="ml-3 date point-blue"
                >{{ todoNotice.startDate | momentDate('YYYY.MM.DD') }} -
                {{ todoNotice.endDate | momentDate('YYYY.MM.DD') }}</span
              >
            </p>
          </v-col>
        </v-row>
        <v-row class="my-0 mx-n8">
          <v-col
            v-for="(fileInfo, index) in todoNotice.info.files"
            cols="12"
            class="px-8 mb-n6 text-center info-wrap d-flex"
            :class="{ 'mt-11': index == 0 }"
            :key="fileInfo.id.fileTitle"
          >
            <FileInput
              :label="fileInfo.id.fileTitle"
              outlined
              :disabled="!todoNotice.canUpdate"
              class="box-type-01"
              :readonly="todoNotice.complete"
              hide-details="auto"
              v-model="fileInfo.file.fileName"
              dense
              :maxSize="fileInfo.fileLimitSize"
              ref="assignmentFile"
              :rules="[fileInfo.requiredYn == 'Y' ? rules.required : '']"
              :checkRequired="fileInfo.requiredYn == 'Y' ? true : false"
              @change:file="_file => uploadAddStepFile(_file, fileInfo)"
              @clear="
                () =>
                  beforeDelete(
                    $refs.assignmentFile[index],
                    fileInfo.file.fileId,
                  )
              "
            >
            </FileInput>
          </v-col>
        </v-row>
      </template>
      <template #actions="{close}">
        <v-card-actions class="base-popup-content-actions d-flex">
          <i-btn
            v-if="todoNotice.complete"
            :disabled="!todoNotice.canUpdate"
            class="ml-auto"
            @click="todoCancel(close, 'ASSIGNMENT')"
            elevation="0"
            color="#363c43"
          >
            <span class="white--text">{{ $t('제출 취소') }}</span>
          </i-btn>
          <i-btn
            v-else
            :disabled="!todoNotice.canUpdate"
            class="ml-auto"
            @click="todoDone(close, 'ASSIGNMENT')"
            elevation="0"
            color="#087ef7"
          >
            <span class="white--text">{{ $t('최종제출') }}</span>
          </i-btn>
        </v-card-actions>
      </template>
    </BasePopup>

    <BasePopup
      v-if="todoNotice"
      title="부가정보 입력"
      v-model="addEtcPopup"
      width="940"
    >
      <v-tabs v-model="addEtcTab" color="#363c43" class="modal-tab bd-B-1px">
        <v-tab v-if="groupByUse.baseYn">{{ $t('기본사항') }}</v-tab>
        <v-tab v-if="groupByUse.addrYn">{{ $t('주소정보') }}</v-tab>
        <v-tab v-if="groupByUse.familyYn">{{ $t('가족사항') }}</v-tab>
        <v-tab v-if="groupByUse.bankYn">{{ $t('은행정보') }}</v-tab>
        <v-tab v-if="todoNotice.info.uploadYn == 'Y'">{{
          $t('파일업로드')
        }}</v-tab>
      </v-tabs>
      <v-tabs-slider color="#363c43"></v-tabs-slider>
      <v-tabs-items v-model="addEtcTab">
        <v-tab-item v-if="groupByUse.baseYn">
          <v-form ref="base" :readonly="todoNotice.complete">
            <dir class="my-4 d-flex justify-end"></dir>
            <div class="bd-T-2px bd-B-2px">
              <v-row
                v-for="(item, index) in groupByUse.baseYn.list"
                :key="item.key"
                :class="{
                  'bd-B-1px': index != groupByUse.baseYn.list.length - 1,
                }"
                class="ma-0"
              >
                <v-col class="pa-0 pl-4 col-auto head-title">
                  {{ $t(item.name) }}
                </v-col>
                <v-col class="pa-0">
                  <div class="px-6 py-3 d-flex align-center">
                    <CommonDatePicker
                      v-if="item.key == 'impairmentDate'"
                      v-model="todoBase[item.key]"
                      clearable
                      @change="saveTodo('base')"
                    />
                    <i-text-field
                      v-else
                      outlined
                      single-line
                      @blur="saveTodo('base')"
                      hide-details="auto"
                      v-model="todoBase[item.key]"
                      :rules="[
                        item.key == 'regiNo' ? rules.regiNo : () => true,
                      ]"
                      dense
                    >
                    </i-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-tab-item>
        <v-tab-item v-if="groupByUse.addrYn">
          <v-form ref="addr" :readonly="todoNotice.complete">
            <dir class="my-4 d-flex justify-end"></dir>

            <div
              class="bd-B-2px"
              v-for="(item, index) in groupByUse.addrYn.list"
              :class="{ 'bd-T-2px': index == 0 }"
              :key="item.key"
            >
              <v-row
                class="ma-0"
                :class="{
                  'bd-B-1px': index != groupByUse.addrYn.list.length - 1,
                }"
              >
                <v-col class="pa-0 pl-4 col-auto head-title">
                  {{ $t(item.name) }}
                </v-col>
                <v-col class="pa-0">
                  <div class="px-6 py-3 d-flex align-center">
                    <PopDaumPostCode
                      @apply="
                        addrInfo =>
                          onAddr(
                            addrInfo,
                            todoAddr[item.key == 'oAddr' ? 'O' : 'B'],
                          )
                      "
                      :disabled="todoNotice.complete"
                      style="width:100%"
                    >
                      <template #activator="{on,attrs}">
                        <i-text-field
                          v-on="on"
                          label="주소"
                          v-bind="attrs"
                          outlined
                          hide-details="auto"
                          v-model="
                            todoAddr[item.key == 'oAddr' ? 'O' : 'B'].addr
                          "
                          :rules="[rules.required]"
                          :prepend-inner-icon="mdiMapMarker"
                          readonly
                          dense
                        >
                        </i-text-field>

                        <i-text-field
                          class="mt-4"
                          label="상세주소"
                          @blur="saveTodo('addr')"
                          outlined
                          hide-details="auto"
                          v-model="
                            todoAddr[item.key == 'oAddr' ? 'O' : 'B'].addrDetail
                          "
                          :rules="[rules.required]"
                          @keydown.enter="saveTodo('addr')"
                          dense
                        />
                      </template>
                    </PopDaumPostCode>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-tab-item>
        <v-tab-item v-if="groupByUse.familyYn">
          <v-form ref="family" :readonly="todoNotice.complete">
            <dir class="my-4 d-flex justify-end"></dir>

            <div class="bd-T-2px bd-B-2px">
              <v-simple-table>
                <thead>
                  <tr>
                    <th
                      class="text-left"
                      v-for="item in groupByUse.familyYn.list"
                      :key="item.key"
                    >
                      {{ $t(item.name) }}
                    </th>
                    <th class="text-center">
                      {{ $t('삭제') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(member, i) in todoFamily" :key="i + 'member'">
                    <td
                      v-for="item in groupByUse.familyYn.list"
                      :key="item.key + 'value' + i"
                    >
                      <v-radio-group
                        v-if="item.key == 'familyDeductionYn'"
                        v-model="member.familyDeductionYn"
                        @change="saveTodo('family')"
                      >
                        <i-radio label="여" value="Y" />
                        <i-radio label="부" value="N" />
                      </v-radio-group>

                      <CommonDatePicker
                        v-else-if="item.key == 'familyBirthday'"
                        v-model="member[item.key]"
                        :rules="v => !!v || '필수값입니다.'"
                        @change="saveTodo('family')"
                      />

                      <DirectInputSelect
                        v-else-if="item.key == 'familyRel'"
                        :items="cvItems.familyRel.items"
                        dense
                        :useDirect="cvItems.familyRel.useDirect"
                        v-model="member.id.familyRel"
                        outlined
                        :rules="[rules.required]"
                        @change="
                          member.id.familyName &&
                            member.id.familyRel &&
                            saveTodo('family')
                        "
                        single-line
                        hide-details="auto"
                      />
                      <i-text-field
                        validate-on-blur
                        v-else-if="item.key == 'familyName'"
                        dense
                        v-model="member.id.familyName"
                        @blur="
                          member.id.familyName &&
                            member.id.familyRel &&
                            saveTodo('family')
                        "
                        outlined
                        :rules="[rules.required]"
                        hide-details="auto"
                      />
                      <i-text-field
                        validate-on-blur
                        v-else
                        v-model="member[item.key]"
                        dense
                        @blur="saveTodo('family')"
                        outlined
                        :rules="[
                          item.key == 'familyRegiNo'
                            ? rules.regiNo
                            : rules.required,
                        ]"
                        hide-details="auto"
                      />
                    </td>
                    <td>
                      <v-icon
                        @click="
                          () => {
                            todoFamily.splice(i, 1);
                            saveTodo('family');
                          }
                        "
                        :disabled="todoNotice.complete"
                        class="material-icons-outlined"
                        >delete</v-icon
                      >
                    </td>
                  </tr>
                  <tr
                    style="background-color:#f2f2f2"
                    v-if="!todoNotice.complete"
                  >
                    <td
                      :colspan="groupByUse.familyYn.list.length + 1"
                      class="text-center"
                    >
                      <span
                        style="opacity:0.7;cursor:pointer"
                        @click="addFamily"
                      >
                        {{ $t('가족 일원 추가하기') }}
                        <v-icon class="material-icons-outlined" color="#087ef7">
                          add_circle
                        </v-icon>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </v-form>
        </v-tab-item>
        <v-tab-item v-if="groupByUse.bankYn">
          <v-form ref="bank" :readonly="todoNotice.complete">
            <dir class="my-4 d-flex justify-end"></dir>
            <div class="bd-T-2px bd-B-2px">
              <v-row
                class="ma-0"
                v-for="(item, index) in groupByUse.bankYn.list"
                :class="{
                  'bd-B-1px': index != groupByUse.bankYn.list.length - 1,
                }"
                :key="item.key"
              >
                <v-col class="pa-0 pl-4 col-auto head-title">
                  {{ $t(item.name) }}
                </v-col>
                <v-col class="pa-0">
                  <div class="px-6 py-3 d-flex align-center">
                    <DirectInputSelect
                      v-if="item.key == 'bankName'"
                      :items="cvItems.bankName.items"
                      dense
                      :useDirect="cvItems.bankName.useDirect"
                      v-model="todoBank[item.key]"
                      outlined
                      @change="saveTodo('bank')"
                      :rules="[rules.required]"
                      single-line
                      hide-details="auto"
                    />
                    <i-text-field
                      v-else
                      v-model="todoBank[item.key]"
                      :rules="[rules.required, rules.number]"
                      dense
                      @blur="saveTodo('bank')"
                      outlined
                      single-line
                      hide-details="auto"
                    >
                    </i-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-tab-item>
        <v-tab-item v-if="todoNotice.info.uploadYn == 'Y'">
          <v-form ref="uploadFile" :readonly="todoNotice.complete">
            <h3 class="mt-7 mb-2">{{ $t('업로드 파일') }}</h3>
            <div class="bd-T-2px bd-B-2px">
              <v-row
                v-for="(fileInfo, index) in todoNotice.info.files"
                :key="fileInfo.id.fileTitle"
                class="ma-0"
                :class="{
                  'bd-B-1px': index != todoNotice.info.files.length - 1,
                }"
              >
                <v-col
                  class="pa-0 pl-4 col-auto head-title d-flex justify-space-between align-center"
                >
                  {{ fileInfo.id.fileTitle }}
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-on="on"
                        v-bind="attrs"
                        size="20"
                        color="#000000"
                        class="material-icons-outlined mdi mr-3"
                      >
                        info
                      </v-icon>
                    </template>
                    <span style="color:#fff">{{
                      fileInfo.fileUploadGuide
                    }}</span>
                  </v-tooltip>
                </v-col>
                <v-col class="pa-0">
                  <div class="px-6 py-3 d-flex align-center">
                    <FileInput
                      :disabled="!todoNotice.canUpdate"
                      label="파일이름"
                      outlined
                      single-line
                      :readonly="todoNotice.complete"
                      hide-details="auto"
                      v-model="fileInfo.file.fileName"
                      dense
                      :maxSize="fileInfo.fileLimitSize"
                      :ref="`addEtcFile-${index}`"
                      :rules="[
                        fileInfo.requiredYn == 'Y' ? rules.required : [],
                      ]"
                      :checkRequired="fileInfo.requiredYn == 'Y' ? true : false"
                      @change:file="_file => uploadAddStepFile(_file, fileInfo)"
                      @clear="
                        () =>
                          beforeDelete(
                            $refs.addEtcFile[index],
                            fileInfo.file.fileId,
                          )
                      "
                    >
                    </FileInput>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-tab-item>
      </v-tabs-items>

      <template #actions="{close}">
        <v-card-actions class="base-popup-content-actions d-flex">
          <i-btn
            v-if="todoNotice.complete"
            :disabled="!todoNotice.canUpdate"
            class="ml-auto"
            @click="todoCancel(close, 'ADDETC')"
            elevation="0"
            color="#363c43"
          >
            <span class="white--text">{{ $t('제출 취소') }}</span>
          </i-btn>
          <i-btn
            v-else
            :disabled="!todoNotice.canUpdate"
            class="ml-auto"
            @click="todoDone(close, 'ADDETC')"
            elevation="0"
            color="#087ef7"
          >
            <span class="white--text">{{ $t('최종제출') }}</span>
          </i-btn>
        </v-card-actions>
      </template>
    </BasePopup>
    <BasePopup
      v-if="todoNotice"
      title="부가정보 입력"
      v-model="addEtcBefroePopup"
      width="600"
    >
      <template v-if="addEtcBefroeStep == 0">
        <h2>{{ todoNotice.title }}</h2>
        <p class="modal-desc mt-4" style="white-space: pre-wrap;">
          {{ todoNotice.notiDesc }}
        </p>
        <v-row class="my-0 mx-n8">
          <v-col cols="12" class="mt-10 px-8 py-6 mb-n6 text-center info-wrap">
            <p class="info-title d-flex align-center justify-center">
              <v-icon
                size="20"
                color="#000000"
                class="material-icons-outlined mdi"
                >date_range</v-icon
              ><span>{{ $t('작성기간') }}</span
              ><span class="ml-3 date point-blue"
                >{{ todoNotice.startDate | momentDate('YYYY.MM.DD') }} -
                {{ todoNotice.endDate | momentDate('YYYY.MM.DD') }}</span
              >
            </p>
          </v-col>
        </v-row>
      </template>
      <template v-else-if="addEtcBefroeStep == 1">
        <h2 class="modal-title">{{ $t('개인정보 처리방침 동의') }}</h2>
        <p class="modal-desc mt-4 pa-5" v-html="agreeInfo.content"></p>
        <div class="agree-wrap">
          <p
            class="all-agree mt-5 d-flex align-center cursor"
            :class="{ checked: agreeInfo.agreed }"
            @click="agreeInfo.agreed = !agreeInfo.agreed"
          >
            <v-icon size="24" class="material-icons-outlined mdi">done</v-icon
            ><span class="ml-2">{{ $t('모두 동의하기') }}</span>
            <input hidden v-model="agreeInfo.agreed" />
          </p>
          <ul class="agree-list mb-4">
            <li
              class="d-flex align-center cursor"
              :class="{ checked: agreeInfo.agreed }"
              @click="agreeInfo.agreed = !agreeInfo.agreed"
            >
              <v-icon size="24" class="material-icons-outlined mdi">done</v-icon
              ><span class="ml-2">{{
                $t('개인정보처리방침에 동의합니다.')
              }}</span
              ><span class="required-txt">{{ $t('(필수)') }}</span>
              <input hidden v-model="agreeInfo.agreed" />
            </li>
          </ul>
        </div>
      </template>
      <template #actions="{close}">
        <v-card-actions
          v-if="addEtcBefroeStep == 0"
          class="base-popup-content-actions d-flex justify-center"
        >
          <i-btn
            @click="beforeWriteAddEtc(close)"
            elevation="0"
            color="#087ef7"
            width="300"
          >
            <span class="white--text">{{ $t('작성하기') }}</span>
          </i-btn>
        </v-card-actions>
        <v-card-actions
          v-else-if="addEtcBefroeStep == 1"
          class="base-popup-content-actions d-flex justify-space-between"
        >
          <v-col cols="6" class="py-0 pl-0" style="padding-right:5px;">
            <i-btn
              block
              outlined
              color="#d5d8dc"
              @click="close()"
              elevation="0"
            >
              <span class="black--text">{{ $t('취소') }}</span>
            </i-btn>
          </v-col>
          <v-col cols="6" class="py-0 pr-0" style="padding-left:5px;">
            <i-btn
              block
              color="#087ef7"
              @click="agree(close)"
              :disabled="!agreeInfo.agreed"
              elevation="0"
            >
              <span class="white--text">{{ $t('확인') }}</span>
            </i-btn>
          </v-col>
        </v-card-actions>
      </template>
    </BasePopup>
  </vue-custom-scrollbar>
</template>

<script>
import { addTaskQueue, groupBy } from '@/utils/util';
import { API } from '@/api/network';
import FileInput from './FileInput.vue';
import CommonDatePicker from '@/components/common/CommonDatePicker.vue';
import PopDaumPostCode from '@/components/items/PopDaumPostCode.vue';
import moment from 'moment';
import { mdiMapMarker } from '@mdi/js';
import DirectInputSelect from '@/components/common/DirectInputSelect.vue';
import { snack } from '@/plugins/dialog/api';
const defaultFamily = () => ({
  id: {
    annoId: '',
    applNo: '',
    familyRel: '',
    familyName: '',
  },
  familyRegiNo: '',
  familyBirthday: '',
  familyDeductionYn: 'Y',
  updateDate: '',
  updateId: '',
  note: '',
});

const defaultAddEtcItems = () => ({
  groupByUse: {},
  todoBase: {
    id: {
      annoId: '',
      applNo: '',
    },
    regiNo: '',
    veteransName: '',
    impairmentDate: '',
    impairmentNo: '',
    updateDate: '',
    updateId: '',
  },
  todoFamily: [],
  todoAddr: {
    O: {
      id: { annoId: '', applNo: '', addrType: 'O' },
      zonecode: '',
      addr: '',
      addrDetail: '',
      addrEng: '',
      roadAddr: '',
      roadAddrEng: '',
      jibunAddr: '',
      jibunAddrEng: '',
      buildingCode: '',
      buildingName: '',
      apartment: '',
      sido: '',
      sidoEng: '',
      sigungu: '',
      sigunguEng: '',
      sigunguCode: '',
      roadnameCode: '',
      bcode: '',
      roadname: '',
      roadnameEng: '',
      bname: '',
      bnameEng: '',
      bname1: '',
      bname1Eng: '',
      bname2: '',
      bname2Eng: '',
      hname: '',
      updateDate: '',
      updateId: '',
    },
    B: {
      id: { annoId: '', applNo: '', addrType: 'B' },
      zonecode: '',
      addr: '',
      addrDetail: '',
      addrEng: '',
      roadAddr: '',
      roadAddrEng: '',
      jibunAddr: '',
      jibunAddrEng: '',
      buildingCode: '',
      buildingName: '',
      apartment: '',
      sido: '',
      sidoEng: '',
      sigungu: '',
      sigunguEng: '',
      sigunguCode: '',
      roadnameCode: '',
      bcode: '',
      roadname: '',
      roadnameEng: '',
      bname: '',
      bnameEng: '',
      bname1: '',
      bname1Eng: '',
      bname2: '',
      bname2Eng: '',
      hname: '',
      updateDate: '',
      updateId: '',
    },
  },
  todoBank: {
    id: {
      annoId: '',
      applNo: '',
    },
    bankName: '',
    bankNo: '',
    updateDate: '',
    updateId: '',
  },
  cvItems: {
    familyRel: {
      useDirect: true,
      items: [],
    },
    bankName: {
      useDirect: true,
      items: [],
    },
  },
});
export default {
  props: {
    isCurrentTab: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pendingAddStepCount() {
      return (this.noticeAddStepList || []).filter(n => !n.complete).length;
    },
  },
  components: {
    FileInput,
    CommonDatePicker,
    PopDaumPostCode,
    DirectInputSelect,
  },
  data() {
    return {
      mdiMapMarker,
      noticeAddStepList: [],
      assignmentPopup: false,
      addEtcBefroePopup: false,
      addEtcBefroeStep: 0,
      todoNotice: null,
      addEtcTab: 0,
      addEtcPopup: false,
      agreeInfo: {
        content: '',
        agreed: false,
      },
      ...defaultAddEtcItems(),
      rules: {
        required: v => !!v || '필수입력 사항입니다.',
        regiNo: v =>
          /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))[-]*[1-8][0-9]{6}$/.test(
            v,
          ) || '주민번호 형식에 맞게 작성해주세요.',
        number: v => !isNaN(v.replaceAll('-', '')) || '잘못된 형식입니다.',
      },
    };
  },

  mounted() {
    this.fetchAddStep();
  },

  methods: {
    groupBy,
    emitBadge() {
      this.$emit('badge', { count: this.pendingAddStepCount });
    },
    async fetchAddStep() {
      this.noticeAddStepList = [];
      const { data } = await API.getAuthJson('/todoList/addStep');
      this.noticeAddStepList = data;
      this.emitBadge();
    },
    onClick(index, event) {
      this.$refs.assignmentFile?.[index]?.[event]?.();
    },
    async openTodoPopup(target) {
      await this.fetchTodoNotice(target);
      if (this.todoNotice.notiType == 'ADDETC') {
        if (target.complete) return (this.addEtcPopup = true);
        this.addEtcBefroePopup = true;
      } else if (this.todoNotice.notiType == 'ASSIGNMENT')
        this.assignmentPopup = true;
    },
    async fetchAgree() {
      this.agreeInfo = {
        content: '',
        agreed: false,
      };
      const close = this.$showLoading();
      try {
        const { data } = await API.getAuthJson('/todo/addEtc/agree', {
          annoId: this.todoNotice.id.annoId,
        });
        this.agreeInfo.content = data.content;
        return data.agreed;
      } catch (error) {
        console.error(error);
      } finally {
        close();
      }
    },
    async agree(closePopup) {
      const close = this.$showLoading();
      try {
        await API.postAuthJson('/todo/addEtc/agree', {
          annoId: this.todoNotice.id.annoId,
        });

        closePopup();
        this.addEtcPopup = true;
      } catch (error) {
        console.error(error);
      } finally {
        close();
      }
    },
    async todoCancel(popupclose, notiType) {
      if (this.todoNotice?.notiType != notiType)
        return this.$showAlert({
          title: '알림',
          message: `잘못된 요청입니다.`,
        });

      const answer = await this.$confirm(`제출을 취소하시겠습니까?`);
      if (!answer) return;

      await API.postAuthJson('/todo/cancel', {
        annoId: this.todoNotice.id.annoId,
        addStepId: this.todoNotice.id.addStepId,
        applNo: this.todoNotice.id.applNo,
        notiType: this.todoNotice.id.notiType,
      });
      this.$showAlert(`제출이 취소 되었습니다.`);
      this.fetchAddStep();
      popupclose();
    },
    async todoDone(popupclose, notiType) {
      //파일 확인 - 과제제출
      if (notiType == 'ASSIGNMENT' && this.todoNotice.info.files.length > 0) {
        const fileInputComponent = this.$refs.assignmentFile;
        for (var i = 0; i < fileInputComponent.length; i++) {
          const hasFile = fileInputComponent[i].hasFile();
          //필수값인 경우만 체크
          if (fileInputComponent[i].checkRequired) {
            if (!hasFile) {
              return this.$showAlert({
                title: '알림',
                message:
                  i +
                  1 +
                  `번째 업로드파일은 필수 항목입니다. \n파일을 선택해 주세요.`,
              });
            }
          }
        }
      }

      //파일 확인 - 부가정보 입력
      if (notiType === 'ADDETC' && this.todoNotice.info.files.length > 0) {
        const files = this.todoNotice.info.files;

        for (let j = 0; j < files.length; j++) {
          const fileComponent = this.$refs[`addEtcFile-${j}`];

          if (!fileComponent) {
            console.warn(`파일 컴포넌트가 존재하지 않습니다: addEtcFile-${j}`);
            continue;
          }

          const isRequired = files[j].requiredYn === 'Y';
          const hasFile =
            fileComponent.hasFile?.() || !!files[j].file?.fileName; // 보조 체크

          if (isRequired && !hasFile) {
            return this.$showAlert({
              title: '알림',
              message: `${j +
                1}번째 업로드파일은 필수 항목입니다. \n파일을 선택해 주세요.`,
            });
          }
        }
      }

      if (this.todoNotice?.notiType != notiType)
        return this.$showAlert({
          title: '알림',
          message: `잘못된 요청입니다.`,
        });

      const confirm = await this.$showAlert({
        title: '알림',
        useCancel: true,
        message: `입력하신 내용을 최종 제출하시겠습니까?`,
      });

      if (!confirm) return;

      const close = this.$showLoading();
      try {
        if (notiType == 'ADDETC') {
          const useList = [];
          this.groupByUse.baseYn && useList.push('base');
          this.groupByUse.addrYn && useList.push('addr');
          this.groupByUse.familyYn && useList.push('family');
          this.groupByUse.bankYn && useList.push('bank');
          this.todoNotice.info.uploadYn == 'Y' && useList.push('uploadFile');

          for (let i = 0; i < useList.length; i++) {
            const canNext = await this.validate(useList[i], true);
            if (!canNext) return;
          }
        }
        await API.postAuthJson('/todo/complete', {
          annoId: this.todoNotice.id.annoId,
          addStepId: this.todoNotice.id.addStepId,
          applNo: this.todoNotice.id.applNo,
          notiType: this.todoNotice.id.notiType,
        });
        popupclose();
        await this.$showAlert(`제출 되었습니다.`);
        this.fetchAddStep();
      } catch (error) {
        await this.$showAlert(
          error.response?.data?.message || '잘못된 요청입니다',
        );
        console.error(error);
      } finally {
        close();
      }
    },
    async beforeWriteAddEtc(close) {
      // fetch 확인서 체크했는지 확인
      const isChecked = await this.fetchAgree();
      if (isChecked) {
        close();
        this.addEtcPopup = true;
      } else this.addEtcBefroeStep = 1;
    },
    async beforeDelete(targetEl, fileId) {
      const answer = await this.$showAlert({
        title: '알림',
        message: '삭제 하시겠습니까?',
        useCancel: true,
      });
      if (answer != true) return;
      targetEl.clear();
      this.deleteAddStepFile(fileId);
    },
    async deleteAddStepFile(fileId) {
      if (!this.todoNotice || !fileId) return;
      const close = this.$showLoading();
      try {
        await API.postAuthJson('/addStep/file/delete', {
          fileId,
          annoId: this.todoNotice.id.annoId,
          applNo: this.todoNotice.id.applNo,
        });
      } catch (error) {
        console.error(error);
      } finally {
        close();
        this.fetchAddStep();
      }
    },
    async fetchTodoNotice(target) {
      this.todoNotice = null;
      Object.assign(this, defaultAddEtcItems());
      const close = this.$showLoading();
      try {
        const { data } = await API.getAuthJson('/todoNotice', { ...target.id });
        data.info.files.forEach(fileInfo => {
          if (!fileInfo.file) fileInfo.file = { fileName: '', fileId: '' };
        });
        //fileSeq 순서대로 정렬
        data.info.files.sort((a, b) => a.fileSeq - b.fileSeq);
        if (data.notiType == 'ADDETC') {
          if (data.info.todoBase) {
            if (data.info.todoBase.impairmentDate)
              data.info.todoBase.impairmentDate = moment(
                data.info.todoBase.impairmentDate,
              ).format('YYYY-MM-DD');

            this.todoBase = data.info.todoBase;
          }
          if (data.info.todoAddr?.length) {
            this.todoAddr.O =
              data.info.todoAddr.find(v => v.id?.addrType == 'O') ||
              this.todoAddr.O;
            this.todoAddr.B =
              data.info.todoAddr.find(v => v.id?.addrType == 'B') ||
              this.todoAddr.B;
          }
          if (data.info.todoFamily?.length) {
            this.todoFamily = data.info.todoFamily;
            this.todoFamily.forEach(member => {
              if (member.familyBirthday)
                member.familyBirthday = moment(member.familyBirthday).format(
                  'YYYY-MM-DD',
                );
            });
          }
          if (data.info.todoBank) {
            this.todoBank = data.info.todoBank;
          }
          if (data.info.groupByUse) {
            this.groupByUse = data.info.groupByUse;
          }
        }
        this.todoNotice = data;

        [
          {
            section: 'family',
            col: 'familyRel',
            use: this.todoNotice.info.familyYn == 'Y',
          },
          {
            section: 'bank',
            col: 'bankName',
            use: this.todoNotice.info.bankYn == 'Y',
          },
        ].forEach(({ section, col, use }) => {
          use &&
            API.getAuthJson('/cv/items', {
              annoId: this.todoNotice.id.annoId,
              section,
              col,
            }).then(({ data: entity }) => {
              this.cvItems[col].items = entity.items?.split('#') ?? [];
              this.cvItems[col].useDirect = entity.directInput == 'Y';
            });
        });
      } catch (error) {
        const message =
          error.response?.data || '내용을 불러오는 중 오류가 발생하였습니다.';
        this.$showAlert({ message, title: '', callback: null });
      } finally {
        close();
      }
    },
    async uploadAddStepFile(file, fileInfo) {
      if (!this.todoNotice) return;
      const close = this.$showLoading();
      try {
        const formData = new FormData();
        const info = {
          annoId: this.todoNotice.id.annoId,
          stepId: this.todoNotice.stepId,
          applNo: this.todoNotice.id.applNo,
          addStepId: this.todoNotice.id.addStepId,
          beforeFileId: fileInfo.file.fileId,
          title: fileInfo.id.fileTitle,
          fileSeq: fileInfo.fileSeq,
          addStepType: fileInfo.id.addStepType,
        };
        if (file && file instanceof File) {
          formData.append('file', file, file.name);
        }
        formData.append(
          'info',
          new Blob([JSON.stringify(info)], { type: 'application/json' }),
        );

        await API.postMultipart('/addStep/file/upload', formData);
      } catch (error) {
        console.error(error);
      } finally {
        close();
      }
    },
    onAddr(info, target) {
      const {
        address: addr,
        addressEnglish: addrEng,
        zonecode,
        roadAddress: roadAddr,
        roadAddressEnglish: roadAddrEng,
        jibunAddress: jibunAddr,
        jibunAddressEnglish: jibunAddrEng,
        buildingCode,
        buildingName,
        apartment,
        sido,
        sidoEnglish: sidoEng,
        sigungu,
        sigunguEnglish: sigunguEng,
        sigunguCode,
        roadnameCode,
        roadname,
        roadnameEnglish: roadnameEng,
        bcode,
        bname,
        bnameEng,
        bname1,
        bname1English: bname1Eng,
        bname2,
        bname2English: bname2Eng,
        hname,
      } = info;
      Object.assign(target, {
        addr,
        addrEng,
        zonecode,
        roadnameCode,
        roadAddr,
        roadnameEng,
        roadAddrEng,
        jibunAddr,
        jibunAddrEng,
        buildingName,
        buildingCode,
        apartment,
        sido,
        sidoEng,
        sigungu,
        sigunguEng,
        roadname,
        bcode,
        sigunguCode,
        bname,
        bnameEng,
        bname1,
        bname1Eng,
        bname2,
        bname2Eng,
        hname,
      });
      this.saveTodo('addr');
    },

    addFamily() {
      this.todoFamily.push(defaultFamily());
    },
    /**
     * @param {'bank'|'family'|'base'|'addr'} target
     */
    async saveTodo(target) {
      try {
        if (this.todoNotice.complete || !(await this.validate(target))) return;
        let payload = null;

        switch (target) {
          case 'bank':
            payload = this.todoBank;

            break;
          case 'family':
            payload = this.todoFamily?.map(v => ({
              ...v,
              familyBirthday: moment(v.familyBirthday).format('YYYYMMDD'),
            })); // array
            break;
          case 'base':
            payload = this.todoBase;
            this.todoBase.regiNo = this.todoBase.regiNo?.replace(/[^0-9]/g, '');
            break;
          case 'addr':
            payload = [this.todoAddr.O, this.todoAddr.B]; // array

            break;
        }

        [payload].flat().forEach(entity => {
          if (!entity.id.annoId) entity.id.annoId = this.todoNotice.id.annoId;
          if (!entity.id.applNo) entity.id.applNo = this.todoNotice.id.applNo;
        });
        await API.postAuthJson(`/todo/${target}`, {
          payload,
          noticeId: this.todoNotice.id,
        });
        snack.info('저장되었습니다.');

        // this.fetchTodoNotice(this.todoNotice);
      } catch (error) {
        this.$showAlert('저장에 실패하였습니다. 제출 기간을 확인하세요');
        console.error(error);
      }
    },
    /**
     * @param {'bank'|'family'|'base'|'addr'|'uploadFile'} target
     * @param {boolean} forSubmit 최종제출 에서 사용하는 validate 여부
     */
    async validate(target) {
      let index = 0;
      const map = {};
      if (this.groupByUse.baseYn) map.base = index++;
      if (this.groupByUse.addrYn) map.addr = index++;
      if (this.groupByUse.familyYn) map.family = index++;
      if (this.groupByUse.bankYn) map.bank = index++;
      if (this.todoNotice.info.uploadYn == 'Y') map.uploadFile = index++;
      if (!this.$refs[target]) {
        this.addEtcTab = map[target];
        await addTaskQueue();
      }

      if (this.$refs[target].validate()) return true;
      else this.addEtcTab = map[target];
    },
  },
  watch: {
    addEtcBefroePopup(open) {
      !open && (this.addEtcBefroeStep = 0);
    },
  },
  /**
   * @param {'bank'|'family'|'base'|'addr'} target
   */
};
</script>

<style lang="scss" scoped>
.todo-complete {
  font-weight: bold;
  color: #087ef7;
}
.cursor {
  cursor: pointer;
}
</style>
